import React from "react";
import { Grid } from "@mui/material";
import { format } from "date-fns";
import LabeledText from "../../Widgets/LabeledText";
import { MedicalHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: MedicalHistoryFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  const formatDate = (date: Date | null) => date ? format(date, "MM/dd/yyyy") : "-";

  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Does the client have any allergies? If yes, what allergies?"
        value={formValues.allergies.length ? formValues.allergies.filter(Boolean).map((a: any) => typeof a === 'string' ? a.replace(/_/g, ' ').toLowerCase() : String(a)).join(', ') : "-"}
      />
      <LabeledText
        label="Has the client ever had an emergency room visit? If yes, provide date(s)"
        value={formValues.emergencyRoomVisits}
      />
      <LabeledText
        label="Has the client had a recent vision screen completed? If yes, list any interventions."
        value={formValues.visionScreen}
      />
      <LabeledText
        label="Is this client at risk of falling due to physical limitations or environmental risks?"
        value={formValues.fallRisk}
      />
      <LabeledText
        label="When was the client's last dental exam and cleaning?"
        value={formatDate(formValues.lastDentalExam)}
      />
      <LabeledText
        label="When was the client's last well-visit with a primary care physician?"
        value={formatDate(formValues.lastWellVisit)}
      />
    </Grid>
  );
};

export default ViewFields;
